import React, { Component } from 'react';
import Plx from 'react-plx';

import './Bird.css';
import { speed } from '../../Config';

import MouthUp from './MouthUp';
import MouthDown from './MouthDown';
import BigCircle from './BigCircle';
import SmallCircle from './SmallCircle';
import Eye from './Eye';
import Glare from './Glare';
import BigGlare from './BigGlare';

import A from './A';
import G from './G';
import R from './R';
import O from './O';
import N from './N';

const bigCircle = [
  {
    start: 0,
    end: `${1.5 * speed}vh`,
    easing: [0.25, 0.1, 0.8, 1.5],
    properties: [
      {
        startValue: 0,
        endValue: -500,
        property: 'translateY',
      },
      {
        startValue: 0,
        endValue: -200,
        property: 'translateX',
      },
      {
        startValue: 1,
        endValue: 0,
        property: 'opacity',
      },
    ]
  },
];

const smallCircle = [
  {
    start: 0,
    end: `${1.35 * speed}vh`,
    easing: [0.25, 0.1, 0.8, 1.5],
    properties: [
      {
        startValue: 0,
        endValue: -200,
        property: 'translateY',
      },
      {
        startValue: 0,
        endValue: -300,
        property: 'translateX',
      },
      {
        startValue: 1,
        endValue: 0,
        property: 'opacity',
      },
    ]
  },
]

const eye = [
  {
    start: 0,
    end: `${2.1 * speed}vh`,
    easing: [0.25, 0.1, 0.8, 1.5],
    properties: [
      {
        startValue: 0,
        endValue: -300,
        property: 'translateY',
      },
      {
        startValue: 0,
        endValue: 100,
        property: 'translateX',
      },
      {
        startValue: 1,
        endValue: 0,
        property: 'opacity',
      },
    ]
  },
];

const glare = [
  {
    start: 0,
    end: `${2.4 * speed}vh`,
    easing: [0.25, 0.1, 0.8, 1.5],
    properties: [
      {
        startValue: 0,
        endValue: -100,
        property: 'translateY',
      },
      {
        startValue: 0,
        endValue: -100,
        property: 'translateX',
      },
      {
        startValue: 1,
        endValue: 0,
        property: 'opacity',
      },
      {
        startValue: 0,
        endValue: 120,
        unit: 'deg',
        property: 'rotate',
      },
    ]
  },
];

const bigGlare = [
  {
    start: 0,
    end: `${2.4 * speed}vh`,
    easing: [0.25, 0.1, 0.8, 1.5],
    properties: [
      {
        startValue: 0,
        endValue: -200,
        property: 'translateY',
      },
      {
        startValue: 0,
        endValue: -200,
        property: 'translateX',
      },
      {
        startValue: 1,
        endValue: 0,
        property: 'opacity',
      },
      {
        startValue: 0,
        endValue: 120,
        unit: 'deg',
        property: 'rotate',
      },
    ]
  },
];

const l1 = [
  {
    start: 0,
    end: `${2.2 * speed}vh`,
    easing: [0.25, 0.1, 0.8, 1.5],
    properties: [
      {
        startValue: 0,
        endValue: 300,
        property: 'translateY',
      },
      {
        startValue: 0,
        endValue: -500,
        property: 'translateX',
      },
      {
        startValue: 1,
        endValue: 0,
        property: 'opacity',
      },
      {
        startValue: 0,
        endValue: -120,
        unit: 'deg',
        property: 'rotate',
      },
    ]
  },
]

const l2 = [
  {
    start: 0,
    end: `${2 * speed}vh`,
    easing: [0.25, 0.1, 0.8, 1.5],
    properties: [
      {
        startValue: 0,
        endValue: 500,
        property: 'translateY',
      },
      {
        startValue: 0,
        endValue: -300,
        property: 'translateX',
      },
      {
        startValue: 1,
        endValue: 0,
        property: 'opacity',
      },
      {
        startValue: 0,
        endValue: 180,
        unit: 'deg',
        property: 'rotate',
      },
    ]
  },
]

const l3 = [
  {
    start: 0,
    end: `${1.8 * speed}vh`,
    easing: [0.25, 0.1, 0.8, 1.5],
    properties: [
      {
        startValue: 0,
        endValue: 700,
        property: 'translateY',
      },
      {
        startValue: 0,
        endValue: -100,
        property: 'translateX',
      },
      {
        startValue: 1,
        endValue: 0,
        property: 'opacity',
      },
      {
        startValue: 0,
        endValue: -90,
        unit: 'deg',
        property: 'rotate',
      },
    ]
  },
]

const l4 = [
  {
    start: 0,
    end: `${2.6 * speed}vh`,
    easing: [0.25, 0.1, 0.8, 1.5],
    properties: [
      {
        startValue: 0,
        endValue: 350,
        property: 'translateY',
      },
      {
        startValue: 0,
        endValue: 100,
        property: 'translateX',
      },
      {
        startValue: 1,
        endValue: 0,
        property: 'opacity',
      },
      {
        startValue: 0,
        endValue: -90,
        unit: 'deg',
        property: 'rotate',
      },
    ]
  },
]

const l5 = [
  {
    start: 0,
    end: `${1.8 * speed}vh`,
    easing: [0.25, 0.1, 0.8, 1.5],
    properties: [
      {
        startValue: 0,
        endValue: 150,
        property: 'translateY',
      },
      {
        startValue: 0,
        endValue: 250,
        property: 'translateX',
      },
      {
        startValue: 1,
        endValue: 0,
        property: 'opacity',
      },
      {
        startValue: 0,
        endValue: -120,
        unit: 'deg',
        property: 'rotate',
      },
    ]
  },
]

const mouthUp = [
  {
    start: 0,
    end: `${1.2 * speed}vh`,
    easing: [0.25, 0.1, 0.8, 1.5],
    properties: [
      {
        startValue: 0,
        endValue: 500,
        property: 'translateX',
      },
      {
        startValue: 1,
        endValue: 0,
        property: 'opacity',
      },
      {
        startValue: 0,
        endValue: -120,
        unit: 'deg',
        property: 'rotate',
      },
    ]
  },
]

const mouthDown = [
  {
    start: 0,
    end: `${1.3 * speed}vh`,
    easing: [0.25, 0.1, 0.8, 1.5],
    properties: [
      {
        startValue: 0,
        endValue: -200,
        property: 'translateY',
      },
      {
        startValue: 0,
        endValue: 600,
        property: 'translateX',
      },
      {
        startValue: 1,
        endValue: 0,
        property: 'opacity',
      },
      {
        startValue: 0,
        endValue: 120,
        unit: 'deg',
        property: 'rotate',
      },
    ]
  },
]

export class index extends Component {
  render() {
    return (
      <div className="bird-wrapper" >
        <Plx
          className="bird-img"
          parallaxData={ bigCircle }
          animateWhenNotInViewport={ true }
        >
          <BigCircle
            className="bird-img"
          />
        </Plx>
        <Plx
          className="bird-img"
          parallaxData={ smallCircle }
          animateWhenNotInViewport={ true }
        >
          <SmallCircle
            className="bird-img"
          />
        </Plx>
        <Plx
          className="bird-img"
          parallaxData={ eye }
          animateWhenNotInViewport={ true }
        >
          <Eye
            className="bird-img"
          />
        </Plx>
        <Plx
          className="bird-img"
          parallaxData={ glare }
          animateWhenNotInViewport={ true }
        >
          <Glare
            className="bird-img"
          />
        </Plx>
        <Plx
          className="bird-img"
          parallaxData={ bigGlare }
          animateWhenNotInViewport={ true }
        >
          <BigGlare
            className="bird-img"
          />
        </Plx>
        <Plx
          className="bird-img"
          parallaxData={ mouthDown }
          animateWhenNotInViewport={ true }
        >
          <MouthDown
            className="bird-img"
          />
        </Plx>
        <Plx
          className="bird-img"
          parallaxData={ mouthUp }
          animateWhenNotInViewport={ true }
        >
          <MouthUp
            className="bird-img"
          />
        </Plx>
          <Plx
            className="bird-img"
            parallaxData={ l1 }
            animateWhenNotInViewport={ true }
          >
            <A className="bird-img" />
          </Plx>
          <Plx
            parallaxData={ l2 }
            animateWhenNotInViewport={ true }
            className="bird-img"
          >             
            <G className="bird-img" />
          </Plx>
          <Plx
            parallaxData={ l3 }
            animateWhenNotInViewport={ true }
            className="bird-img"
          >                
            <R className="bird-img" />
          </Plx>
          <Plx
            parallaxData={ l4 }
            animateWhenNotInViewport={ true }
            className="bird-img"
          >       
            <O className="bird-img" />
          </Plx>
          <Plx
            parallaxData={ l5 }
            animateWhenNotInViewport={ true }
            className="bird-img"
          >
            <N className="bird-img" />
          </Plx>
          <div className="bird-dummy" />
      </div>
    );
  };
};

export default index;
